






























import { Vue, Component, Watch, Emit } from 'vue-property-decorator';
import AMSEditForm from './AMSEditForm.vue';
import AMSBreadcrumb from '@/components/AMSBreadcrumb.vue';
import request from '@/utils/request';
import { AppStore } from '@/store/modules/app';
import AMSTable from '@/components/AMSTable.vue';
import AMSSelectedProduct from '@/components/AMSSelectedProduct.vue';
import AMSProduct from '@/components/AMSProductCategorySelector.vue';
import AMSCustomerDiscount from './../AMSDiscount.vue';
import { createOrEdit } from '@/api/customer';
import Utils from '@/utils/utils';
interface DeliveryAddresses {
  name?: string;
  regionId?: number;
  address?: string;
  phone?: string;
  isDefault?: boolean;
}

interface ProductDiscounts {
  productId?: string;
  discountPrice?: number;
  status?: string;
  id?: string;
}

interface ProductCategoryDicounts {
  productCategoryId?: string;
  discountRate?: number;
  status?: string;
  id?: string;
}

interface Form {
  name?: string;
  phone?: string;
  contactPerson?: string;
  sales?: Array<any>;
  beautyAdvisors?: Array<any>;
  levelId?: string;
  signDate?: string;
  contactPhone?: string;
  settlementType?: string;
  deliveryAddresses?: Array<DeliveryAddresses>;
  regionId?: number;
  address?: string;
  productDiscounts?: Array<ProductDiscounts>;
  productCategoryDicounts?: Array<ProductCategoryDicounts>;
  hiddenProductDiscounts?: Array<ProductDiscounts>;
}

@Component({
  components: {
    'ams-breadcrumb': AMSBreadcrumb,
    'ams-edit-form': AMSEditForm,
    'ams-table': AMSTable,
    'ams-discount': AMSCustomerDiscount,
  },
})
export default class CustomerCreate extends Vue {
  valid = false;
  phonevalid = true;
  tabValue: number = 0;
  form: Form = {
    signDate: new Date().toISOString().substr(0, 10),
    settlementType: 'PrePayment',
    deliveryAddresses: [{}],
    sales: [],
    beautyAdvisors: []
  };
  breadItems = [
    {
      text: '客户管理',
      disabled: false,
      href: '/customer'
    },
    {
      text: '客户列表',
      disabled: false,
      href: '/customer'
    },
    {
      text: '新增客户',
      disabled: true
    }
  ];
  addloading: Boolean = false;
  changeTab(value: number) {
    this.tabValue = value;
  }
  discountChange(discountTable: any) {
    this.form = Object.assign({}, this.form, discountTable);
  }

  addressChange(address: any) {
    this.form.deliveryAddresses = address;
  }
  selectChange(staff: any) {
    this.form = Object.assign({}, this.form, staff);
  }
  phoneValid(value: boolean) {
    this.phonevalid = value;
  }
  save() {
    if (!this.phonevalid) {
      AppStore.ShowError('手机号已重复');
      return false;
    }
    if ((this.$refs.form as HTMLFormElement).validate()) {
      let filterProductDiscounts: any = [],
        filterProductCategoryDicounts: any = [],
        filterDeliveryAddresses: any = [],
        filterHiddenProductDiscounts: any = [],
        error = false;

      filterHiddenProductDiscounts =
        this.form.hiddenProductDiscounts &&
        this.form
          .hiddenProductDiscounts!.filter((f: ProductDiscounts) => {
            return f.id;
          })
          .map((p: ProductDiscounts) => {
            if (!p.discountPrice) {
              error = true;
              this.tabValue = 2;
              AppStore.ShowError('折扣价不能为空！');
            }
            return { productId: p.id, discountPrice: p.discountPrice };
          });

      filterProductDiscounts =
        this.form.productDiscounts &&
        this.form
          .productDiscounts!.filter((f: ProductDiscounts) => {
            return f.id;
          })
          .map((p: ProductDiscounts) => {
            if (!p.discountPrice) {
              error = true;
              this.tabValue = 1;
              AppStore.ShowError('折扣价不能为空！');
            }
            return { productId: p.id, discountPrice: p.discountPrice };
          });
      filterProductCategoryDicounts =
        this.form.productCategoryDicounts &&
        this.form
          .productCategoryDicounts!.filter((f: ProductCategoryDicounts) => {
            return f.id;
          })
          .map((c: ProductCategoryDicounts) => {
            if (!c.discountRate) {
              error = true;
              this.tabValue = 1;
              AppStore.ShowError('折扣率不能为空！');
            }
            return { productCategoryId: c.id, discountRate: c.discountRate };
          });

      filterDeliveryAddresses =
        this.form.deliveryAddresses &&
        this.form
          .deliveryAddresses!.map((f: DeliveryAddresses | null, index: number) => {
            for (var key of Object.keys(f!)) {
              if (!(f as any)[key]) {
                delete (f as any)[key];
              }
            }
            if (Object.keys(f!).length == 0) {
              f = null;
            } else {
              if (!f!.name) {
                error = true;
                AppStore.ShowError('请填写收货人');
              }
              if (!f!.regionId) {
                error = true;
                AppStore.ShowError('请填写省市区');
              }
              if (!f!.address) {
                error = true;
                AppStore.ShowError('请填写收货详细地址');
              }
              if (!f!.phone) {
                error = true;
                AppStore.ShowError('请填写手机号');
              }
              if (f!.phone && !/^1[3-9][0-9]{9}$/.test(f!.phone)) {
                error = true;
                AppStore.ShowError('手机号格式不正确');
              }
              if (this.form.deliveryAddresses!.length == 1 && index == 0) {
                f!.isDefault = true;
              }
            }
            return f;
          })
          .filter((f: any) => {
            return f;
          });
      if (this.form.regionId) {
        if (!this.form.address) {
          error = true;
          AppStore.ShowError('请填写详细地址');
        }
      }
      if (this.form.address) {
        if (!this.form.regionId) {
          error = true;
          AppStore.ShowError('请填写所属区域');
        }
      }
      if (error) return;
      this.addloading = true;
      let formData = Object.assign({}, this.form, {
        productDiscounts: filterProductDiscounts,
        productCategoryDicounts: filterProductCategoryDicounts,
        deliveryAddresses: filterDeliveryAddresses,
        hiddenProductDiscounts: filterHiddenProductDiscounts,
      });
      createOrEdit(formData).then((data) => {
        Utils.clearAllSearchPage(this.$route.name as string);
        this.addloading = false;
        this.$router.push({
          name: 'customer_index'
        });
      });
    }
  }
  goBack() {
    this.$router.go(-1);
  }
}
